/**
 * This code is adapted from https://github.com/strues/retinajs
 */
class Retina {
    static hasWindow = typeof window !== "undefined";
    static environment = Math.round(
        this.hasWindow ? window.devicePixelRatio || 1 : 1,
    );
    static srcReplace = /(\.[A-z]{3,4}\/?(\?.*)?)$/;
    static inlineReplace = /url\((['"])?([^)'"]+)(['"])?\)/i;
    static selector = "[data-rjs]";
    static processedAttr = "data-rjs-processed";

    static chooseCap(cap) {
        const numericCap = parseInt(cap, 10);
        return this.environment < numericCap ? this.environment : numericCap;
    }

    static forceOriginalDimensions(image) {
        if (!image.hasAttribute("data-no-resize")) {
            if (image.offsetWidth === 0 && image.offsetHeight === 0) {
                image.setAttribute("width", image.naturalWidth);
                image.setAttribute("height", image.naturalHeight);
            } else {
                image.setAttribute("width", image.offsetWidth);
                image.setAttribute("height", image.offsetHeight);
            }
        }
        return image;
    }

    static setSourceIfAvailable(image, retinaURL) {
        const imgType = image.nodeName.toLowerCase();
        const testImage = document.createElement("img");
        testImage.addEventListener("load", () => {
            if (imgType === "img") {
                this.forceOriginalDimensions(image).setAttribute(
                    "src",
                    retinaURL,
                );
            } else {
                image.style.backgroundImage = "url(" + retinaURL + ")";
            }
        });
        testImage.setAttribute("src", retinaURL);
        image.setAttribute(this.processedAttr, true);
    }

    static dynamicSwapImage(image, src, rjs = 1) {
        const cap = this.chooseCap(rjs);
        if (src && cap > 1) {
            const newSrc = src.replace(this.srcReplace, "@" + cap + "x$1");
            this.setSourceIfAvailable(image, newSrc);
        }
    }

    static manualSwapImage(image, src, hdsrc) {
        if (this.environment > 1) {
            this.setSourceIfAvailable(image, hdsrc);
        }
    }

    static getImages(images) {
        if (!images) {
            return typeof document !== "undefined"
                ? [...document.querySelectorAll(this.selector)]
                : [];
        } else {
            return typeof images.forEach === "function" ? images : [...images];
        }
    }

    static cleanBgImg(img) {
        return img.style.backgroundImage.replace(this.inlineReplace, "$2");
    }

    static retina(images = null) {
        this.getImages(images).forEach((img) => {
            if (!img.getAttribute(this.processedAttr)) {
                const isImg = img.nodeName.toLowerCase() === "img";
                const src = isImg
                    ? img.getAttribute("src")
                    : this.cleanBgImg(img);
                const rjs = img.getAttribute("data-rjs");
                const rjsIsNumber = !isNaN(parseInt(rjs, 10));

                if (null === rjs) {
                    return;
                }

                if (rjsIsNumber) {
                    this.dynamicSwapImage(img, src, rjs);
                } else {
                    this.manualSwapImage(img, src, rjs);
                }
            }
        });
    }
}

export default Retina;
